import { render, staticRenderFns } from "./WineryCo2Metrics.vue?vue&type=template&id=3e084cbd&scoped=true&"
import script from "./WineryCo2Metrics.vue?vue&type=script&lang=js&"
export * from "./WineryCo2Metrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e084cbd",
  null
  
)

export default component.exports